import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { SlideMenuService } from '../../services/slide-menu.service';
import { MAIN_MENU } from '../../data/items-main-menu.data';
import { MenuItem } from '../../models/menu-item.model';
import { SpinnerService } from '../../services/spinner.service';
import { ChatwootService } from '../../services/chatwoot.service';

@Component({
  selector: 'app-main-layout',
  templateUrl: './main-layout.component.html',
  styleUrl: './main-layout.component.scss'
})
export class MainLayoutComponent implements OnInit {

  public menuItems:MenuItem[] = MAIN_MENU;

  constructor(
    public slideMenuService: SlideMenuService,
    public spinnerService: SpinnerService,
    private chatwootService: ChatwootService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) { }

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      this.chatwootService.init();
    }
  }

}
